import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "components/ui";
import styles from "./dialog.module.scss";
import { CommonModalProps } from "./common";

interface TemplateDialogProps extends CommonModalProps {}

const TemplateDialog = ({
  onAction,
  onCloseAction,
  isOpen,
  title,
  description,
  action,
}: TemplateDialogProps) => {
  const toggle = () => {
    onCloseAction();
  };
  return (
    <Modal
      isOpen={isOpen}
      style={{ width: "100%", maxWidth: "440px" }}
      className={styles["modal"]}
      contentClassName={styles["modal-content"]}
      centered
      data-testid="modal"
    >
      <ModalHeader className={styles["header"]} toggle={toggle}></ModalHeader>
      <ModalBody className={styles["body"]} data-testid="modal-body">
        <p className={styles["title"]}>{title}</p>
        <p className={`text-small ${styles["description"]}`}>{description}</p>
      </ModalBody>
      <ModalFooter className={styles["footer"]} data-testid="modal-footer">
        <Button
          variant="primary"
          onClick={() => {
            onAction();
            onCloseAction();
          }}
          className="sans"
        >
          {action}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TemplateDialog;
